function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentCurrencyRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.41c.313-.496.665-.967 1.05-1.41-1.36-.36-3.19-1-3.19-3a2.74 2.74 0 011.73-2.28 3.53 3.53 0 01.41-.16V5h2v1.48a6.5 6.5 0 012.78 1.38l-1.28 1.5c-1.13-.91-2.24-1.24-3-.91a1.001 1.001 0 00-.62.62c0 .51.38.74 2 1.16.28.08.58.16.88.26A12 12 0 0119.49 8 9 9 0 108 19.49a12.29 12.29 0 011-4.36 8.52 8.52 0 01-2-1.21l1.26-1.51a6.92 6.92 0 001.74 1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10a10 10 0 100 20 10 10 0 000-20zm-4 14.3v-1.85h2.87v-1H16v-1.89h1.7l-2.63-5.1h2.86l2.19 5.1 2.17-5.1H25l-2.63 5.1h1.74v1.85h-2.85v1h2.85v1.89h-2.85v2.17h-2.44V24.3H16z",
    fill: props.color
  }));
}

export default SvgIconPaymentCurrencyRexFilled;